import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ClientRegisteredVendorInvoice } from './client-registered-vendor-invoice';

export class ClientRegisteredVendorInvoiceFee extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ClientRegisteredVendorInvoiceFeeProperties: (
    | {
        property: keyof ClientRegisteredVendorInvoiceFee;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ClientRegisteredVendorInvoiceFee;
        type: 'alias';
      }
    | {
        property: keyof ClientRegisteredVendorInvoiceFee;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorInvoiceId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'feeType', type: 'column', dataType: 'string' },
    { property: 'feeAmt', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    {
      property: 'ClientRegisteredVendorInvoice',
      model: 'ClientRegisteredVendorInvoice',
      type: 'association'
    }
  ];

  static {
    ClientRegisteredVendorInvoiceFee.ClientRegisteredVendorInvoiceFeeProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          ClientRegisteredVendorInvoiceFee.columnMap.set(
            property,
            propertyObject
          );
        }
        if (type === 'alias') {
          ClientRegisteredVendorInvoiceFee.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          ClientRegisteredVendorInvoiceFee.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(
    ClientRegisteredVendorInvoiceFeeObject: Partial<ClientRegisteredVendorInvoiceFee>
  ) {
    super();

    ClientRegisteredVendorInvoiceFee.ClientRegisteredVendorInvoiceFeeProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = ClientRegisteredVendorInvoiceFeeObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  ClientRegisteredVendorInvoiceId?: number;
  feeType?:
    'STANDARD' | 'IRS TIN MATCH' | 'TINCHECK ONLY' | 'CORPORATE FILING REPORT';
  feeAmt?: number;
  createdAt?: Date;
  updatedAt?: Date;

  ClientRegisteredVendorInvoice?: ClientRegisteredVendorInvoice;
}
